import {AurDataGridColDef} from '../types/types';
import {t} from 'i18next';
import { getUTCDateTimeForDisplay } from './utils';
import { ONLY_DATE_SHOW_FORMAT } from '../constants/constants';

/*
Column name for concierge reports table
*/
export const getConciergeReportColumns = (): AurDataGridColDef[] => [
  {
    field: 'select',
    headerName: '',
    width: 15,
    minWidth: 15,
    sortable: false,
  },
  {
    field: 'fileName',
    headerName: t('conciergeReports.fileName'),
    minWidth: 300,
    flex: 1,
    sortable: true,
  },
  {
    field: 'description',
    headerName: t('conciergeReports.description'),
    minWidth: 300,
    flex: 1,
    sortable: false,
  },
  {
    field: 'client',
    headerName: t('conciergeReports.client'),
    minWidth: 140,
    flex: 1,
    sortable: true,
  },
  {
    field: 'project',
    headerName: t('conciergeReports.project'),
    minWidth: 250,
    flex: 1,
    sortable: true,
    renderCell: (params) => {
      const {project, projectCode} = params.row;
      params.value = project + (projectCode ? ' (' + projectCode + ')' : '');
      return params.value;
    },
  },
  {
    field: 'updateDate',
    headerName: t('conciergeReports.uploadDate'),
    minWidth: 90,
    flex: 1,
    sortable: true,
    isDateColumn: true,
    renderCell: (params) => {
      return (
        <span>{getUTCDateTimeForDisplay(params.value, ONLY_DATE_SHOW_FORMAT)}</span>
      );
    },
  },
  {
    field: 'updateUser',
    headerName: t('conciergeReports.uploadedBy'),
    minWidth: 100,
    flex: 1,
    sortable: true,
    isBorderNotRequired: true,
  },
];
